import { render, staticRenderFns } from "./EventQuestionAddContent.vue?vue&type=template&id=319a462c"
import script from "./EventQuestionAddContent.vue?vue&type=script&lang=js"
export * from "./EventQuestionAddContent.vue?vue&type=script&lang=js"
import style0 from "./EventQuestionAddContent.vue?vue&type=style&index=0&id=319a462c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports